import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import {
  CheckCircle as CompletedIcon, PersonOff as ClientAbsentIcon,
  EventBusy as TrainerAbsentIcon, ArrowDropDown as ArrowIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { sessionStatus } from 'common/constants/options';

/**
 * Menú "Marcar como" del entrenador: Completó / Cliente ausente / Entrenador ausente.
 * Botón monocromo (sin azul); los íconos usan los tokens semáforo de sesión.
 */
function SessionMarkMenu({ onMark, disabled = false }) {
  const theme = useTheme();
  const { t } = useTranslation(['sessions']);
  const [anchorEl, setAnchorEl] = useState(null);

  const options = [
    { value: sessionStatus.finished, label: t('markCompleted', { ns: 'sessions', defaultValue: 'Completó' }), icon: <CompletedIcon fontSize="small" sx={{ color: theme.palette.sessionStatus.completed.fg }} /> },
    { value: sessionStatus.clientAbsent, label: t('markClientAbsent', { ns: 'sessions', defaultValue: 'Cliente ausente' }), icon: <ClientAbsentIcon fontSize="small" sx={{ color: theme.palette.sessionStatus.absent.fg }} /> },
    { value: sessionStatus.trainerAbsent, label: t('markTrainerAbsent', { ns: 'sessions', defaultValue: 'Entrenador ausente' }), icon: <TrainerAbsentIcon fontSize="small" sx={{ color: theme.palette.sessionStatus.absent.fg }} /> }
  ];

  const handle = (value) => { onMark(value); setAnchorEl(null); };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        endIcon={<ArrowIcon />}
        disabled={disabled}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ color: 'text.primary', borderColor: 'hairline.strong', textTransform: 'none', fontWeight: 700, whiteSpace: 'nowrap' }}
      >
        {t('markAs', { ns: 'sessions', defaultValue: 'Marcar como' })}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {options.map((o) => (
          <MenuItem key={o.value} onClick={() => handle(o.value)}>
            <ListItemIcon>{o.icon}</ListItemIcon>
            <Typography variant="body2">{o.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

SessionMarkMenu.propTypes = {
  onMark: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default SessionMarkMenu;
